import { faMagnifyingGlass } from '@awesome.me/kit-4a6bf60416/icons/classic/regular';

import { Icon } from '@/components/ui/icon';
import { TextInput, type TextInputProps } from './text-input';

type SearchInputProps = Omit<TextInputProps, 'leftSection' | 'type'>;

export function SearchInput(props: SearchInputProps) {
  return (
    <TextInput type="search" leftSection={<Icon icon={faMagnifyingGlass} size="sm" />} {...props} />
  );
}
